<template>
  <div class="mt20 mc statistical-page">
    <!-- <div class="w100 pt20 pl20 pr20 flex-box tab-bar" v-if="routerList.length">
      <router-link class="cu-p tab-bar-item" v-for="(item, index) in routerList" :key="index" :class="item.index == value ? 'active' : null" :to="item.path">
        {{ item.name }}
      </router-link>
    </div> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Statistical",
  components: {},
  props: [],
  data() {
    return {
      value: "",
      routerList: [
        {
          name: "大厅统计",
          path: "/statistical/all"
        },
        {
          name: "部门统计",
          path: "/statistical/department"
        },
        {
          name: "学院统计",
          path: "/statistical/college"
        },
        {
          name: "个人统计",
          path: "/statistical/user"
        }
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};
</script>

<style scoped>
.tab-bar {
  background: #fff;
  border-bottom: 1px solid #248ff0;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.tab-bar-item {
  margin-right: 10px;
  padding: 0.5em 1.5em;
  border: 1px solid #ccc;
  border-bottom: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-size: 14px;
}

.tab-bar-item:hover {
  border-color: #248ff0;
  color: #248ff0;
}

.tab-bar-item.router-link-active {
  color: #fff;
  background: #248ff0;
  border-color: #248ff0;
}
</style>
